import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _get from 'lodash.get';
import NewStoryCard from 'components_v2/desktop/NewStoryCard';
import BreadCrumb from 'components_v2/common/BreadCrumb/BreadCrumb';
import Slider from 'react-slick';
// eslint-disable-next-line no-unused-vars
// import slickcss from 'slick-carousel/slick/slick.css';
import timeago from 'timeago.js';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import AdCaller from 'helpers/ads/adCaller';
import WithGeo from 'helpers/ads/WithGeo';
import InViewObserver from 'components/InViewObserver';
import ButtonPreferredSources from 'components_v2/common/ButtonPreferredSources';
import { earnAboundPoints } from 'components_v2/common/Abound/redux';
import LoadableComponentLoader from 'components_v2/common/LoadableComponentLoader/LoadableComponentLoader';
import TrendingSlider from '../../../../components_v2/desktop/TrendingSlider/TrendingSlider';
import RenderAds from '../../../home/components/desktop/RenderAds/RenderAds';
import VideoPlayer from '../../components/common/VideoPlayer/VideoPlayer';
import { playNextVideo } from '../../../../components/LitePlayer/util';
// import SocialWidget from '../../../articleshow_v2/components/common/SocialWidget/SocialWidget';
import s from './Videoshow.scss';
import { loadVideoshowData } from '../../redux';
import EtimesCoverLayout from '../../../../components_v2/desktop/EtimesCoverLayout/EtimesCoverLayout';
import {
  getSiteDomain,
  fireCustomDimension,
  getCustomDimension45,
  fireGA4Script,
  padVideoDurationTimestamp,
  capitalizeFirstLowercaseRest,
} from '../../../../utils/common';
import { TOI_IMAGE_DOMAIN, TOI_LIVE_DOMAIN } from '../../../../constants';

class Videoshow extends React.Component {
  constructor(props) {
    super(props);
    const { breadCrumbData } = this.props;
    this.secName =
      breadCrumbData && breadCrumbData.length >= 3
        ? breadCrumbData[2].label
        : '';
    this.updateRHSVideoHighlightedIndex = this.updateRHSVideoHighlightedIndex.bind(
      this,
    );
    this.EXPERIMENT_ID_1 = 'Videoshow_web_DesignA';
    this.EXPERIMENT_ID_2 = 'Videoshow_web_DesignB';
    this.state = {
      copied: false,
      showSocialWidget: false,
      thresholds: [10, 750, 1500, 2250],
      designA: false,
      // isLoading: false,
      // relatedArticleData: [],
    };
    this.etimesWidgets = [
      60829791,
      3813445,
      4928542,
      4928546,
      68047985,
      3813443,
      // 49802315,
      64505989,
      69003355,
    ];
  }
  stateforGoogleboot() {
    if (
      navigator &&
      navigator?.userAgent?.toLowerCase().indexOf('googlebot') > -1
    ) {
      this.setState({
        showReadMore: false,
        showReadLess: true,
      });
    }
  }

  analyticsWrapperExperiment = params => {
    analyticsWrapper('ga4', {
      ...params,
    });
  };

  componentDidMount() {
    // if (typeof window !== 'undefined') {
    //   window.TimesApps = window.TimesApps || {};
    //   window.TimesApps.videoshowPageExperimentID = this.getExperimentId(false);
    // }
    // if (
    //   window &&
    //   window.player &&
    //   window.player.updateConfig &&
    //   typeof window.player.updateConfig === 'function'
    // ) {
    //   window.player.updateConfig({
    //     player: {
    //       exp: this.getExperimentId(false),
    //       custom_params: {
    //         exp: this.getExperimentId(false),
    //       },
    //     },
    //   });
    // }
    // this.analyticsWrapperExperiment(false, {
    //   event: 'experiment_tracking',
    // });
    this.videoshowLoadedGA();

    if (
      this.state.thresholds &&
      Array.isArray(this.state.thresholds) &&
      this.state.thresholds.length > 0
    ) {
      window.addEventListener('scroll', this.handleGA4Scroll);
    }
  }

  fireWidgetShownGA = type => {
    this.analyticsWrapperExperiment({
      event: 'user_shown',
      type,
    });
  };

  videoshowLoadedGA = () => {
    const { videoParams, msid } = this.props;

    this.analyticsWrapperExperiment({
      event: 'videoshow_load',
      video_type: 'VideoMain',
      msid,
      slike_id: videoParams?.eid,
    });
  };

  setScrollGA4State = (threshold, ga4label) => {
    this.setState(
      {
        thresholds: [
          ...this.state.thresholds.filter(item => item !== threshold),
          this.state.thresholds[this.state.thresholds.length - 1] + 750,
        ],
      },
      () => {
        if (ga4label) {
          this.analyticsWrapperExperiment({
            event: 'user_scroll',
            type: 'scroll-depth',
            label:
              typeof ga4label === 'string'
                ? ga4label
                : `scroll_${threshold / 750}`,
          });
        }
      },
    );
  };

  handleGA4Scroll = () => {
    // Get the current scroll position
    const scrollPosition = window.scrollY || window.pageYOffset;
    const thresholdsState = this.state.thresholds;
    thresholdsState.forEach(threshold => {
      if (scrollPosition >= threshold) {
        switch (threshold) {
          case 10:
            this.setScrollGA4State(threshold, 'scroll_starts');
            break;
          case 750:
            this.setScrollGA4State(threshold, 'scroll_1');
            break;
          case 1500:
            this.setScrollGA4State(threshold, 'scroll_2');
            break;
          case 2250:
            this.setScrollGA4State(threshold, 'scroll_3');
            break;
          case this.state.thresholds[0]:
            this.setScrollGA4State(this.state.thresholds[0], 1);
            break;
          default:
            break;
        }
      }
    });
  };

  getSectionName = () => {
    const { breadCrumbData } = this.props;
    return breadCrumbData && breadCrumbData.length >= 2
      ? breadCrumbData[1].label
      : '';
  };
  getSubSectionName = () => {
    const { breadCrumbData } = this.props;
    return breadCrumbData && breadCrumbData.length >= 3
      ? breadCrumbData[2].label
      : '';
  };
  // handleClick = () => {
  //   if (typeof window !== 'undefined' && !this.state.designA) {
  //     setTimeout(() => {
  //       const leadWrapOH = document.querySelector('#videostoryCard')
  //         .offsetHeight;
  //       document
  //         .querySelector('#recoslisting')
  //         .setAttribute('style', `height: ${leadWrapOH}px`);
  //     }, 0);
  //   }
  // };

  renderViralItems = () => {
    if (!this.props.viralVideos || !Array.isArray(this.props.viralVideos)) {
      return null;
    }
    const dataArray = this.props.viralVideos;
    const newArray = [];
    for (let i = 0; i < dataArray.length; i += 5) {
      const subArray = dataArray.slice(i, i + 5);
      newArray.push(subArray);
    }
    return newArray;
  };
  renderRecosItems = () => {
    if (
      !this.props.recommendedVideos ||
      !Array.isArray(this.props.recommendedVideos)
    ) {
      return null;
    }
    const dataArray = this.props.recommendedVideos;
    const newArray = [];
    for (let i = 0; i < dataArray.length; i += 6) {
      const subArray = dataArray.slice(i, i + 6);
      newArray.push(subArray);
    }
    return newArray;
  };

  videoEndCallBack = callbackData => {
    const loadedVideoData =
      callbackData &&
      Array.isArray(callbackData.items) &&
      callbackData.items.length > 0
        ? callbackData.items[0]
        : undefined;
    if (loadedVideoData && loadedVideoData.id) {
      const msid = loadedVideoData.id;
      // const plyInst =
      //   typeof window.player === 'object' &&
      //   Array.isArray(window.player) &&
      //   window.player.length > 0
      //     ? window.player[window.player.length - 1]
      //     : window.player;
      const slikeId = loadedVideoData?.eid;
      // plyInst.load({
      //   id: slikeId,
      //   playerType: '',
      //   msid,
      // });
      playNextVideo(`lg_videoshow`, slikeId);
      const url = loadedVideoData?.wu || '';
      this.analyticsWrapperExperiment({
        event: 'user_next_video',
        label: url,
        msid,
        slike_id: slikeId,
      });

      if (
        typeof window !== 'undefined' &&
        window.history &&
        !(window.location.href.indexOf(msid) >= 0)
      ) {
        const newurl = url.replace(TOI_LIVE_DOMAIN, '');
        window.history.pushState({}, 'abc', newurl);
        const updatedMsid = msid || this.props.routeParams?.msid;
        if (
          window.TimesApps &&
          typeof window.TimesApps.SavingsAPI === 'object'
        ) {
          window.TimesApps.SavingsAPI.addCallsToQueue(updatedMsid);
        }
        if (loadedVideoData.unixtimesstamp) {
          fireCustomDimension(
            getCustomDimension45(loadedVideoData.dunixtimesstampl),
            'dimension55',
          );
        }

        fireGA4Script({ vmsid: msid });

        // analyticsWrapper('ga', 'send', 'pageview', url);
      }

      this.setState({
        copied: false,
      });
      if (
        this.descriptionRef &&
        this.descriptionRef.offsetHeight &&
        this.descriptionRef.offsetHeight >= 96
      ) {
        this.setState(
          {
            showReadMore: true,
            showReadLess: false,
          },
          // this.handleClick,
        );
      } else {
        this.setState(
          {
            showReadMore: false,
            showReadLess: false,
          },
          // this.handleClick,
        );
      }
    }
  };

  updateRHSVideoHighlightedIndex(msid) {
    const oldMsid = parseInt(msid, 10);
    const newMsid = this.props.videoParams?.id;
    if (oldMsid !== newMsid) {
      this.props.loadVideoshowData({ msid }, this.videoEndCallBack);
    }
  }

  renderBannerAds = data => (
    <RenderAds adObject={data} isWapView={false} immediateLoad />
  );

  copyLink = () => {
    if (typeof window !== 'undefined' && document) {
      const urlToCopy = window.location.href;
      if (navigator && navigator.clipboard) {
        navigator.clipboard
          .writeText(urlToCopy)
          .then(() => {
            this.setState({ copied: true });
          })
          .catch(err => {
            console.error('Failed to copy: ', err);
          });
      } else {
        const tempInput = document.createElement('input');
        tempInput.value = urlToCopy;
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand('copy');
        document.body.removeChild(tempInput);
        this.setState({ copied: true });
      }
    }
  };

  render() {
    const {
      viralShorts,
      recommendedVideos,
      routeParams,
      breadCrumbData,
      topSearches,
      videoParams,
      isPrime,
      relatedArticles,
    } = this.props;
    const designAcativeCls = this.state.designA ? s.abLayout : '';
    //const recosCountA = isPrime ? 6 : 3;
    const noOfReco = 10; //this.state.designA ? 6 : recosCountA;
    const msid = videoParams ? videoParams.id : routeParams.msid;
    const NextArrow = props => (
      <span {...props} className={`btn next ${props.className}`}>
        <i />
      </span>
    );

    const PrevArrow = props => (
      <span {...props} className={`btn prev ${props.className}`}>
        <i />
      </span>
    );
    const sliderSettings = {
      dots: true,
      slidesToShow: 6,
      slidesToScroll: 6,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
      infinite: false,
      arrows: true,
      autoplay: false,
      autoplaySpeed: 1000,
      // swipeToSlide: true,
      // variableWidth: true,
    };

    const sliderSettingsViralVideo = {
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
      infinite: false,
      arrows: true,
      autoplay: false,
      autoplaySpeed: 1000,
      // swipeToSlide: true,
      // variableWidth: true,
    };

    const sliderSettingsRecos = {
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
      infinite: false,
      arrows: true,
      autoplay: false,
      autoplaySpeed: 1000,
      // swipeToSlide: true,
      // variableWidth: true,
    };

    const showSocialShareWidget = () => {
      this.setState({ showSocialWidget: true });
      // this.analyticsWrapperExperiment({
      //   event: 'user_click',
      //   type: 'socialshare_widget',
      //   category: 'videoshow',
      //   label: 'share',
      // });
    };
    const hideSocialShareWidget = () => {
      this.setState({ showSocialWidget: false });
    };
    // const socialWidgetToggle = event => {
    //   if (event) {
    //     event.stopPropagation();
    //     event.preventDefault();
    //   }
    //   this.setState(prevState => ({
    //     showSocialWidget: !prevState.showSocialWidget,
    //   }));
    // };

    const newViralArray = this.renderViralItems();
    const newRecosArray = this.renderRecosItems();
    const timeagoInstance = timeago();
    const showTopSearches = !!(
      Array.isArray(topSearches) && topSearches.length > 0
    );
    return (
      <>
        {breadCrumbData && (
          <BreadCrumb data={breadCrumbData} wrapperClass="breadcrumb" />
        )}
        {showTopSearches && (
          <div>
            <TrendingSlider
              topSearches={topSearches}
              title={topSearches?.name}
            />
          </div>
        )}
        <div
          className={
            showTopSearches
              ? `${s.videoshowWrapper}`
              : `${s.videoshowWrapper} ${s.pt_16}`
          }
        >
          <div className={`${s.bannerWrap} ${designAcativeCls}`}>
            <div className={s.leadWrap} id="leadWrap">
              <div className={s.videostoryCard} id="videostoryCard">
                <div
                  data-msid={msid}
                  className={`${s.video_player} video_slot`}
                  style={{
                    backgroundImage: `url(${TOI_IMAGE_DOMAIN}/thumb/msid-${msid},width-600,resizemode-4/${msid}.jpg)`,
                  }}
                >
                  <VideoPlayer
                    //sectionadsCode={sectionadsCode}
                    s={s}
                    updateRHSVideoHighlightedIndex={
                      this.updateRHSVideoHighlightedIndex
                    }
                    routeParams={routeParams}
                    videoParams={{
                      ...videoParams,
                      msid,
                    }}
                    isEtimes={this.props.isEtimes}
                    isPrime={isPrime}
                    width={600}
                    skipAds={this.props.skipAds}
                    userData={this.props.userData}
                    earnPoints={this.props.earnPoints}
                  />
                </div>
                <div className={s.descriptionArea}>
                  <div className={s.shareInfo}>
                    <div className={s.dateInfo}>
                      {videoParams?.vw ? `${videoParams?.vw} views | ` : ''}
                      {videoParams?.dl ? `${videoParams.dl} | ` : ''}
                      {videoParams?.source || ''}
                    </div>
                    <div className={s.shareLinks}>
                      <ul>
                        <li>
                          <button
                            className={s.copy}
                            onClick={() => {
                              this.copyLink();
                            }}
                          >
                            <i className={s.copyIcon} />
                            {this.state.copied ? 'Link Copied!' : 'Copy Link'}
                          </button>
                        </li>
                        <li>
                          <div
                            className={`${s.timelineshare}  icon_share_wrap`}
                            // onClick={socialWidgetToggle}
                            onMouseEnter={showSocialShareWidget}
                            onMouseLeave={hideSocialShareWidget}
                          >
                            <i
                              className={`${s.shareIcon} ${
                                this.state.showSocialWidget ? s.active : ''
                              }`}
                            />
                            Share
                            {this.state.showSocialWidget && (
                              // <SocialWidget
                              <LoadableComponentLoader
                                loadableComponentName="SocialWidgetVSDesktop"
                                msid={msid}
                                isParent
                                url={videoParams.wu}
                                title={videoParams.hl}
                                className={s.icon_hover_social}
                                isWapView={false}
                                isSmallicon
                                // openSidebar={this.openSidebar}
                                //isLiveBlog
                                // commentsCount={this.props.commentsCount}
                                wu={videoParams.wu}
                                //via={this.props.via}
                                type="ATF"
                                gaCategory="videoshow_cat"
                                gaAction="click"
                                gaIndex="atfShare_"
                                textRequired={false}
                                linkeDin
                                via="@timesofindia"
                                styles={s}
                                defaultEmailView
                                disableShortUrl
                                platformTemplate="web_videoshow"
                              />
                            )}
                          </div>
                        </li>
                        {/* <li>
                          <a href="#" className={s.timesPoints}>
                            <i className={s.timesIcon} />
                            127 PTS
                          </a>
                        </li> */}
                        <WithGeo
                          render={({ geoCountry }) =>
                            geoCountry === 'US' || geoCountry === 'IN' ? (
                              <li className={s.buttonPreferredSourcesWrapper}>
                                <ButtonPreferredSources label="videoshow_web" />
                              </li>
                            ) : null
                          }
                        />
                      </ul>
                    </div>
                  </div>
                  <h3>{videoParams?.hl}</h3>
                  <div className={`${s.caption_ps}`}>
                    <div
                      className={
                        this.state.showReadLess
                          ? `${s.paraCaption} ${s.show_text}`
                          : `${s.paraCaption}`
                      }
                    >
                      <span
                        className={s.text}
                        dangerouslySetInnerHTML={{
                          __html: videoParams?.Story,
                        }}
                        ref={descriptionRef => {
                          if (!this.descriptionRef) {
                            this.descriptionRef = descriptionRef;
                            if (
                              this.descriptionRef &&
                              this.descriptionRef.offsetHeight >= 96
                            ) {
                              this.setState({
                                showReadMore: true,
                                showReadLess: false,
                              });
                            } else {
                              this.setState({
                                showReadMore: false,
                                showReadLess: false,
                              });
                            }
                          }
                        }}
                      />
                      {this.state.showReadMore && (
                        <span
                          className={s.readMore}
                          onClick={() => {
                            this.setState({
                              showReadMore: false,
                              showReadLess: true,
                            });
                            // this.handleClick();
                          }}
                        >
                          Read More
                        </span>
                      )}
                      {this.state.showReadLess && (
                        <span
                          className={s.readMore}
                          onClick={() => {
                            this.setState({
                              showReadMore: true,
                              showReadLess: false,
                            });
                            // this.handleClick();
                          }}
                        >
                          Read Less
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`${
                this.props.skipAds
                  ? `${s.skipAd} ${s.recomendList}`
                  : s.recomendList
              }`}
              id="recoslisting"
            >
              {!isPrime &&
                !this.props.skipAds && (
                  <div className={s.adWrap}>
                    <RenderAds
                      adObject={{
                        tn: 'ad',
                        adtype: 'dfp',
                        name: 'mrec',
                      }}
                      isWapView={false}
                      immediateLoad
                    />
                  </div>
                )}
              {this.state.designA && (
                <div className={s.listWrap}>
                  <h2>Recommended Playlist</h2>
                  <InViewObserver
                    inViewCallback={() => {
                      this.fireWidgetShownGA('recommondation_widget');
                    }}
                  >
                    <Slider {...sliderSettingsRecos} className="slick_UI">
                      {newRecosArray.map(item => (
                        <>
                          <ul className={s.listing}>
                            {item &&
                              Array.isArray(item) &&
                              item.map((story, index) => (
                                <li key={story.msid}>
                                  <NewStoryCard
                                    title={story.hl}
                                    msid={story.msid}
                                    imagesize={story?.imagesize}
                                    cardType="card_15"
                                    wu={story.url}
                                    cmstype={story.tn}
                                    gaIndex={index + 1}
                                    iconClass="videoshowIcon"
                                    ga4Type="recommondation_widget"
                                    // shouldNotlazyloadImage={shouldNotlazyloadImage}
                                    ga4Label="Recommended Playlist"
                                    videoTime={padVideoDurationTimestamp(
                                      story.du,
                                    )}
                                    createdTime={capitalizeFirstLowercaseRest(
                                      timeagoInstance.format(
                                        new Date(story.lu),
                                      ),
                                    )}
                                  />
                                </li>
                              ))}
                          </ul>
                        </>
                      ))}
                    </Slider>
                  </InViewObserver>
                </div>
              )}
              {!this.state.designA && (
                <div className={s.listWrap}>
                  <InViewObserver
                    inViewCallback={() => {
                      this.fireWidgetShownGA('recommondation_widget');
                    }}
                  >
                    <h2>Recommended Playlist</h2>
                  </InViewObserver>
                  <div className={s.listing}>
                    <ul>
                      {recommendedVideos &&
                        Array.isArray(recommendedVideos) &&
                        recommendedVideos
                          .slice(0, noOfReco)
                          .map((story, index) => (
                            <li key={story.msid}>
                              <NewStoryCard
                                title={story.hl}
                                msid={story.msid}
                                imagesize={story?.imagesize}
                                cardType="card_15"
                                wu={story.url}
                                cmstype={story.tn}
                                gaIndex={index + 1}
                                iconClass="videoshowIcon"
                                ga4Type="recommondation_widget"
                                // shouldNotlazyloadImage={shouldNotlazyloadImage}
                                ga4Label="Recommended Playlist"
                                videoTime={padVideoDurationTimestamp(story.du)}
                                createdTime={
                                  !!story && !!story.lu
                                    ? timeagoInstance.format(
                                        /^\d+$/.test(story.lu)
                                          ? new Date(Number(story.lu))
                                          : new Date(story.lu),
                                      )
                                    : 'just now'
                                }
                              />
                            </li>
                          ))}
                    </ul>
                  </div>
                </div>
              )}
            </div>
          </div>
          {newViralArray &&
            Array.isArray(newViralArray) &&
            newViralArray.length > 0 && (
              <div className={s.viralWrap}>
                <h2>Top Viral Videos</h2>
                <div className={s.viralVideos}>
                  <InViewObserver
                    inViewCallback={() => {
                      this.fireWidgetShownGA('viral_widget');
                    }}
                  >
                    <Slider {...sliderSettingsViralVideo} className="slick_UI">
                      {newViralArray.map((story, index) => (
                        <>
                          <div key={index} className={s.viralVideosElement}>
                            <div className={s.largeVideo}>
                              <div key={story[0].msid}>
                                <NewStoryCard
                                  title={story[0].hl}
                                  msid={story[0].msid}
                                  imagesize={story[0]?.imagesize}
                                  syn={story[0].synopsis}
                                  cardType="card_16"
                                  wu={story[0].url}
                                  cmstype={story[0].tn}
                                  gaIndex={1}
                                  iconClass="videoshowIcon"
                                  ga4Type="viral_widget"
                                  // shouldNotlazyloadImage={shouldNotlazyloadImage}
                                  ga4Label="Viral Playlist"
                                  videoTime={padVideoDurationTimestamp(
                                    story[0].du,
                                  )}
                                  createdTime={`${
                                    !!story &&
                                    story[0] &&
                                    !!story[0].createdTime &&
                                    story[0].createdTime !== ''
                                      ? `${story[0].createdTime}`
                                      : `${
                                          story[0]?.vw
                                            ? `${story[0].vw} views | `
                                            : ''
                                        }${timeagoInstance.format(
                                          new Date(Number(story[0]?.lu)),
                                        )}`
                                  }`}
                                />
                              </div>
                            </div>
                            <div className={s.fourColumn}>
                              <ul>
                                {story.slice(1, 5).map((subItem, subIndex) => (
                                  <li key={subItem.msid}>
                                    <NewStoryCard
                                      title={subItem.hl}
                                      msid={subItem.msid}
                                      imagesize={subItem?.imagesize}
                                      cardType="card_17"
                                      wu={subItem.url}
                                      cmstype={subItem.tn}
                                      gaIndex={subIndex + 2}
                                      iconClass="videoshowIcon"
                                      ga4Type="viral_widget"
                                      // shouldNotlazyloadImage={shouldNotlazyloadImage}
                                      ga4Label="Viral Playlist"
                                      videoTime={padVideoDurationTimestamp(
                                        subItem.du,
                                      )}
                                      createdTime={`${
                                        !!subItem &&
                                        !!subItem.createdTime &&
                                        subItem.createdTime !== ''
                                          ? `${subItem.createdTime}`
                                          : `${
                                              subItem?.vw
                                                ? `${subItem.vw} views | `
                                                : ''
                                            }``${
                                              subItem?.lu
                                                ? timeagoInstance.format(
                                                    new Date(
                                                      Number(subItem.lu),
                                                    ),
                                                  )
                                                : ''
                                            }`
                                      }`}
                                    />
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </div>
                        </>
                      ))}
                    </Slider>
                  </InViewObserver>
                </div>
              </div>
            )}
          {viralShorts &&
            Array.isArray(viralShorts) &&
            viralShorts.length > 0 && (
              <InViewObserver
                inViewCallback={() => {
                  this.fireWidgetShownGA('short_videos_widget');
                }}
              >
                <div className={s.shortWrap}>
                  <div className={s.title}>
                    <h2>Short Videos</h2>
                    {/* <a href="#" className={s.seeAll}>
                See all
              </a> */}
                  </div>
                  <div className={`${s.shortVideos}`}>
                    <Slider {...sliderSettings} className="slick_UI">
                      {viralShorts.slice(0, 18).map((item, index) => (
                        <div key={item.msid} className={s.shortItem}>
                          <NewStoryCard
                            title={item.hl}
                            msid={item.msid}
                            imagesize={item?.imagesize}
                            cardType="card_18"
                            wu={item.url}
                            gaIndex={index + 1}
                            iconClass="videoshowIcon"
                            ga4Type="short_videos_widget"
                            ga4Label="Short Videos"
                            videoTime="SHORT"
                            target="__blank"
                            forceTargetBlank
                            //createdTime="1732 Views"
                          />
                        </div>
                      ))}
                    </Slider>
                  </div>
                </div>
              </InViewObserver>
            )}
          {relatedArticles &&
            Array.isArray(relatedArticles) &&
            relatedArticles.length > 0 && (
              <InViewObserver
                inViewCallback={() => {
                  this.fireWidgetShownGA('relatedarticles_widget');
                }}
              >
                <div className={`${s.relatedWrap} ${s.m_60}`}>
                  <div className={s.title}>
                    <h2>Related Articles</h2>
                  </div>
                  <div className={s.relatedArticle}>
                    {relatedArticles.slice(0, 8).map((item, index) => (
                      <div key={item.msid} className={s.articleItem}>
                        <NewStoryCard
                          title={item.hl}
                          msid={item.msid}
                          imagesize={item?.imagesize}
                          cardType="card_19"
                          wu={item.wu}
                          gaIndex={index}
                          ga4Type="relatedarticles_widget"
                          ga4Label="Related Articles"
                          createdTime={timeagoInstance.format(
                            new Date(Number(item.upd || item.lpt)),
                          )}
                          // createdTime="1732 Views"
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </InViewObserver>
            )}
          {this.props.isEtimes &&
            this.etimesWidgets &&
            Array.isArray(this.etimesWidgets) &&
            this.etimesWidgets.map(widgetID => (
              <div className={s.etimesCoverLayout}>
                <EtimesCoverLayout
                  sectionDataUrl={`${getSiteDomain()}/feeds/feed_videoshow_etimes_widgets/msid-${widgetID},feedtype-sjson.cms`}
                  isPrime={isPrime}
                  key={widgetID}
                />
              </div>
            ))}
          <AdCaller
            adWapperClass={s.adsbox}
            data={{
              name: 'taboola_bottom',
            }}
          />
        </div>
      </>
    );
  }
}
Videoshow.propTypes = {
  routeParams: PropTypes.shape({
    msid: PropTypes.string.isRequired,
  }).isRequired,
  videoParams: PropTypes.shape({}).isRequired,
  viralVideos: PropTypes.shape({}).isRequired,
  viralShorts: PropTypes.shape({}).isRequired,
  recommendedVideos: PropTypes.shape({}).isRequired,
  relatedArticles: PropTypes.shape({}).isRequired,
  breadCrumbData: PropTypes.shape({}).isRequired,
  msid: PropTypes.string,
  skipAds: PropTypes.bool,
};
Videoshow.defaultProps = {
  msid: '',
  skipAds: false,
};
const mapDispatchtoProps = dispatch => ({
  loadVideoshowData: (params, callback) => {
    dispatch(loadVideoshowData(params, callback));
  },
  earnPoints: data => {
    dispatch(earnAboundPoints(data));
  },
});
const mapStateToProps = state => ({
  isPrime: state?.isPrime,
  topSearches:
    _get(state, 'navigation.data.topSearchArray', undefined) ||
    _get(state, 'commonData.data.topSearches.items', undefined),
  videoParams: _get(state, 'videoshow.videoshowData.items[0]', {}),
  recommendedVideos: _get(
    state,
    'videoshow.videoshowData.recommendedVideos',
    [],
  ),
  viralVideos: _get(state, 'videoshow.videoshowData.viralVideos', []),
  viralShorts: _get(state, 'videoshow.videoshowData.viralShorts', []),
  relatedArticles: _get(state, 'videoshow.relatedarticles.items', []),
  userData: _get(state, 'login.userData', null),
});
export default connect(mapStateToProps, mapDispatchtoProps)(Videoshow);
